var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEllipsisVerticalSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ellipsis-vertical-solid",
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.223,
    height: 24,
    viewBox: "0 0 6.223 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ellipsis-vertical-solid-2",
    "data-name": "ellipsis-vertical-solid",
    d: "M11.111,57.778A3.111,3.111,0,1,1,8,60.889,3.113,3.113,0,0,1,11.111,57.778Zm0-8.889A3.111,3.111,0,1,1,8,52,3.113,3.113,0,0,1,11.111,48.889Zm3.111-5.778A3.111,3.111,0,1,1,11.111,40,3.113,3.113,0,0,1,14.222,43.111Z",
    transform: "translate(-8 -40)",
    fill: "#ccd0d1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsisVerticalSolid);
export default __webpack_public_path__ + "static/media/ellipsis-vertical-solid.b6b9acc204438e24b2848bba63208365.svg";
export { ForwardRef as ReactComponent };